// src/components/StationEntry.js
import React, { useState } from 'react'
import Header from './ui/Header'
import PrimaryButton from './ui/PrimaryButton'
import * as content from '../data/content'
import JourneyMap from './JourneyMap'

export default function StationEntry({ city, session, theme, toggleTheme, nextStation = 1, onBegin, onBack, onBackToLanding, onShowLines, cityProgress, skipMap = false }) {
  const cityData    = content.CITIES[city]
  const days        = (content.DAYS || {})[city]
  const stationData = days?.[nextStation - 1]
  const primary     = city === 'berlin' ? '#b89800' : cityData?.primaryColor

  const [showMap, setShowMap] = useState(!skipMap)
  const [exiting, setExiting] = useState(false)

  const handleStationPress = (num) => {
    if (num !== nextStation) return
    setExiting(true)
    setTimeout(() => setShowMap(false), 280)
  }

  const handleBegin = () => {
    const el = document.querySelector('.station-entry-wrap')
    if (el) { el.style.opacity = '0'; el.style.transform = 'translateY(12px)' }
    setTimeout(onBegin, 280)
  }

  // ── MAP VIEW ──
  if (showMap) {
    return (
      <div
        className="jm-prejournal-overlay"
        data-city={city}
        style={{
          opacity: exiting ? 0 : 1,
          transform: exiting ? 'translateY(12px)' : 'translateY(0)',
          transition: 'all 0.28s ease',
        }}
      >
        <Header back={{ label: 'All Lines', onClick: onBack }} />

        <JourneyMap
            city={city}
            cityProgress={cityProgress || (nextStation - 1)}
            mode="prejournal"
            onStationPress={handleStationPress}
            style={{ flex: 1 }}
          />

        <div style={{ padding: '0 var(--screen-padding-x) var(--space-md)' }}>
          <PrimaryButton
            style={{ background: primary }}
            onClick={() => handleStationPress(nextStation)}
          >
            <span>Begin Station {nextStation}</span>
            <span>→</span>
          </PrimaryButton>
        </div>
      </div>
    )
  }

  // ── STATION DETAIL VIEW ──
  return (
    <div className="station-entry-page" data-city={city}>
      <Header back={{ label: 'Your Line', onClick: onBack }} />
      <div className="station-entry-wrap station-entry-animate">

        <div className="station-entry-city-row">
          <div className="station-entry-city-dot" style={{ background: cityData?.primaryColor }} />
          <span className="station-entry-city-label">{cityData?.name} Line</span>
        </div>

        <p className="station-entry-num">Station {nextStation}</p>
        <h2 className="station-entry-name">{stationData?.title || cityData?.name}</h2>

        {stationData?.practice && (
          <p className="station-entry-practice-type">{stationData.practice}</p>
        )}

        <div className="station-entry-divider" />

        <p className="station-entry-intro">
          {stationData?.full || stationData?.short || `Today's journey invites you to slow down and notice what's already here.`}
        </p>

        {stationData?.quote && (
          <div className="station-entry-quote">
            <span className="station-entry-quote-mark">❝</span>
            <span className="station-entry-quote-text">{stationData.quote}</span>
          </div>
        )}

        <PrimaryButton
          style={{ background: cityData?.primaryColor }}
          onClick={handleBegin}
        >
          <span>Begin Today's Journey</span>
          <span>→</span>
        </PrimaryButton>


      </div>
    </div>
  )
}
